<script setup>
import { computed } from 'vue';
import AccordionItem from 'dashboard/components/Accordion/AccordionItem.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useLocoI18n } from 'custom/composables/useLocoI18n';
import { usePixtaConnection } from 'custom/pixta/usePixtaConnection';
import PixtaCustomer from 'custom/pixta/PixtaCustomer.vue';

// A fork section of the conversation sidebar (custom/conversation/sidebarItems.js)
const props = defineProps({
  name: { type: String, required: true },
  conversationId: { type: [Number, String], required: true },
});

const { t } = useLocoI18n();
const { isContactSidebarItemOpen, toggleSidebarUIState } = useUISettings();
const { connection } = usePixtaConnection();

const PIXTA_OPEN_KEY = 'is_pixta_customer_open';

const showsPixta = computed(
  () =>
    props.name === 'pixta_customer' &&
    connection.value?.configured &&
    connection.value?.enabled
);
</script>

<template>
  <AccordionItem
    v-if="showsPixta"
    :title="t('LOCO.PIXTA.TITLE')"
    :is-open="isContactSidebarItemOpen(PIXTA_OPEN_KEY)"
    compact
    @toggle="toggleSidebarUIState(PIXTA_OPEN_KEY)"
  >
    <PixtaCustomer
      v-if="isContactSidebarItemOpen(PIXTA_OPEN_KEY)"
      :conversation-id="conversationId"
    />
  </AccordionItem>
</template>
